export enum ModalName {
  Product = 'AddOrUpdateProductModal',
  Permission = 'AddOrUpdatePermissionModal',
}
